export class VendorMasterModel {

  VendorListAPI: string = "";
  UpdateAPI: string = "";
  VendorByIDAPI: string = "";
  CountryListAPI: string = "";
  StateListAPI: string = "";
  CityListAPI: string = "";
  PublisherListAPI: string = "";
  SourceListAPI: string = "";
  LanguageListAPI: string = "";
  InterestListAPI: string = "";
  TaskListAPI: string = "";
  JournalListAPI: string = "";
  VendorEmailcheckDuplicate: any = "";


}
